export type PsuFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type PsuFilterGroup = {
  id: string;
  label: string;
  options: PsuFilterOption[];
};

export const psuFilterGroups: PsuFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'cooler-master', label: 'Cooler Master', keywords: ['cooler master', 'cm'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus', 'rog', 'tuf'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'fsp', label: 'FSP', keywords: ['fsp'] },
      { value: 'deepcool', label: 'Deepcool', keywords: ['deepcool'] },
      { value: 'seasonic', label: 'Seasonic', keywords: ['seasonic'] },
      { value: 'mik', label: 'MIK', keywords: ['mik'] },
      { value: 'aigo', label: 'Aigo', keywords: ['aigo'] },
      { value: 'segotep', label: 'Segotep', keywords: ['segotep'] },
      { value: 'gigabyte', label: 'Gigabyte', keywords: ['gigabyte', 'aorus'] },
    ],
  },
  {
    id: 'wattage',
    label: 'Công suất',
    options: [
      { value: '450', label: '450W - 550W', keywords: ['450w', '500w', '550w'] },
      { value: '650', label: '650W', keywords: ['650w'] },
      { value: '750', label: '750W', keywords: ['750w'] },
      { value: '850', label: '850W', keywords: ['850w'] },
      { value: '1000', label: '1000W trở lên', keywords: ['1000w', '1200w', '1300w', '1600w'] },
    ],
  },
  {
    id: 'efficiency',
    label: 'Chuẩn hiệu suất',
    options: [
      { value: '80-plus', label: '80 Plus White', keywords: ['80 plus white', '80 plus standard'] },
      { value: 'bronze', label: '80 Plus Bronze', keywords: ['bronze'] },
      { value: 'gold', label: '80 Plus Gold', keywords: ['gold'] },
      { value: 'platinum', label: '80 Plus Platinum', keywords: ['platinum'] },
      { value: 'titanium', label: '80 Plus Titanium', keywords: ['titanium'] },
    ],
  },
  {
    id: 'modular',
    label: 'Kiểu dây',
    options: [
      {
        value: 'non-modular',
        label: 'Non-Modular (Dây liền)',
        keywords: ['non modular', 'day lien'],
      },
      { value: 'semi-modular', label: 'Semi-Modular', keywords: ['semi modular'] },
      {
        value: 'full-modular',
        label: 'Full-Modular (Rời hoàn toàn)',
        keywords: ['full modular', 'day roi'],
      },
    ],
  },
];
